import type { FC, ReactNode } from 'react'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
}

/**
 * Empty state component for tabs with no content
 * Displays an icon, title, description, and optional CTA button
 */
export const EmptyState: FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center py-12 px-4 text-center"
      data-testid="empty-state"
    >
      <div className="text-5xl mb-4 opacity-60" aria-hidden="true">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-sm text-gray-600 mb-6 max-w-sm">
        {description}
      </p>
      {action && (
        <button
          onClick={action.onClick}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 settings-button-lift"
          data-testid="empty-state-action"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}

export default EmptyState
